<!-- TEMPLATE -->
<template>
  <div class="deanDashboardTile gamma-knowledge-base">
    <a href="https://support.gammacommunications.nl/hc/nl" target="_blank" class="widget-content">
      <img src="@/assets/widget/gamma-knowledge-base-logo.png" alt="Gamma Knowledge Base" class="logo">
      <div class="link-text">Inloggen</div>
    </a>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class GammaKnowledgeBaseWidget extends Vue {}
</script>

<!-- STYLE -->
<style lang="scss" scoped>

  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .deanDashboardTile {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 0 0.38rem rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .widget-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    width: 100%;
    outline: none;
  }

  .logo {
    max-width: 80%;
    max-height: 60%;
    object-fit: contain;
  }

  .link-text {
    margin-top: 10px;
    color: #000000;
    font-size: 14px;
    font-weight: normal;
    text-decoration: none;
  }
</style>
